export const UUI_FILTERS_PANEL_ADD_BUTTON = 'uui-filters-panel-add-button';
export const UUI_FILTERS_PANEL_ADD_BUTTON_BODY = 'uui-filters-panel-add-button-body';
export const UUI_FILTERS_PANEL_ITEM_BODY = 'uui-filters-panel-item-body';
export const UUI_FILTERS_PANEL_ITEM_TOGGLER = 'uui-filters-panel-item-toggler';
export const UUI_FILTERS_PANEL_ITEM_TOGGLER_TITLE = 'uui-filters-panel-item-toggler-title';
export const UUI_FILTERS_PANEL_ITEM_TOGGLER_SELECTION = 'uui-filters-panel-item-toggler-selection';
export const UUI_FILTERS_PANEL_ITEM_TOGGLER_POSTFIX = 'uui-filters-panel-item-toggler-postfix';
export const UUI_FILTERS_PANEL_BODY_FOOTER = 'uui-filters-panel-item-footer';
